import { NumericFormControl } from '@cmctechnology/phoenix-stockbroking-web-design';
import { IInputProps } from '@cmctechnology/phoenix-stockbroking-web-design/dist/js/Forms/Input/Input';
import React from 'react';

const MIN_POSITIVE_VALUE = 1;

export const PositiveNumericFormControl = React.forwardRef<HTMLInputElement, Omit<IInputProps, 'ref' | 'type' | 'min'>>(function NumericInput(props, ref) {
  return <NumericFormControl min={MIN_POSITIVE_VALUE} {...props} ref={ref} />;
});
